import React from 'react';
import Holiday from 'components/Tvendo/Setting/Holiday/List';

export default function () {
  return <Holiday />;
}
